import React, { useEffect, useMemo, useState } from 'react';

const AlertModalProvider = ({ children }) => {
  const [queue, setQueue] = useState([]);
  const [activeMessage, setActiveMessage] = useState(null);

  const closeModal = () => {
    setActiveMessage(null);
  };

  useEffect(() => {
    const originalAlert = window.alert;

    window.alert = (message = '') => {
      setQueue((prev) => [...prev, String(message)]);
    };

    return () => {
      window.alert = originalAlert;
    };
  }, []);

  useEffect(() => {
    if (activeMessage !== null || queue.length === 0) {
      return;
    }

    setActiveMessage(queue[0]);
    setQueue((prev) => prev.slice(1));
  }, [activeMessage, queue]);

  const modal = useMemo(() => {
    if (activeMessage === null) {
      return null;
    }

    return (
      <div className="modal-overlay" onClick={closeModal}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h2>Notice</h2>
            <button onClick={closeModal} className="close-btn">✕</button>
          </div>

          <p style={{ whiteSpace: 'pre-line' }}>{activeMessage}</p>

          <div className="modal-actions">
            <button type="button" onClick={closeModal} className="btn btn-primary">
              OK
            </button>
          </div>
        </div>
      </div>
    );
  }, [activeMessage]);

  return (
    <>
      {children}
      {modal}
    </>
  );
};

export default AlertModalProvider;
